import React, {Component, Fragment} from 'react';
import styled from 'styled-components'
// import PropTypes from 'prop-types'
import {withFirebase} from "../../components/Firebase";
import {withRouter} from "react-router";
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
import {chatActions} from "../../store/chat";
import {Backdrop, Block, Input, Overlay, Portal, Tabs} from "reakit";
import {Box, Card, Flex, Heading, Image, Text} from 'rebass';
import {Content, TabHeader} from "../../components/Base";
import {FloatingButton} from "../../components/Base/Buttons";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";
import IosClose from 'react-ionicons/lib/IosClose'
import SearchInput from "../../components/Forms/SearchInput";
import UserList from "../../components/UserList";
import {Action, Fab} from 'react-tiny-fab';
import MdAdd from "react-ionicons/lib/MdAdd";
import MdCreate from "react-ionicons/lib/MdCreate";
import MdTrash from "react-ionicons/lib/MdTrash";
import ConfirmDelete from '../../components/Modals/ConfirmDelete'
import check from "../../resources/img/icons/Checkbox@1x.png";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";


const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
margin: 0;
padding: 0;
`;


/* icon imports */
const ListWrapper = styled(Card)`
min-width: 250px;
	height: 75vh;
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
`;

const HeaderWrapper = styled(Card)`
position: relative;
top: 0;
left: 0;
width: 100vw;
min-height: 150px;
max-height: 150px;
@media(max-width: 700px){
min-height: 142px;
max-height: 142px;
}
`


class ChatMembers extends Component {

	state = {
		selected: [],
		confirmDelete: false,
		edit: false,
		students: [],
		faculty: [],
		name: null,
		changed: false,
		isStudentTab: true
	};

	componentDidMount() {


		this.studentListener = this.props.firebase.students().onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.setState({students: result, loading: false})
			}
		);
		this.facultyListener = this.props.firebase.faculties().onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.setState({faculty: result, loading: false})
			}
		)
	}


	handleSelect = (name) => {
		console.log(name)
		const {edit} = this.state;
		if (edit) {
			let {selected} = this.state;
			// const {handleUpdate} = this.props;
			let contains = false;
			for (var i = selected.length - 1; i >= 0; i--) {
				if (selected[i] === name.id) {
					selected.splice(i, 1);
					contains = true;
					this.setState({selected, changed: true})
					// break;       //<-- Uncomment  if only the first term has to be removed
				}
			}

			if (!contains) {
				selected.push(name.id);
				this.setState({selected, changed: true})
			}
		}


		// handleUpdate(selected)

	};

	handleUpdate = () => {
		const {selected, name} = this.state;
		const {firebase, chat} = this.props;

		try {
			let chatRef = firebase.chat(chat.id)
			chatRef.update({
				members: selected,
				name
			})
		} catch (err) {
			console.log("Failed to update chat: ", err)
		}
		this.toggleEditMode()
	}

	toggleEditMode = () => {
		const {edit} = this.state;
		const {defaultSelected, chat} = this.props;
		if (edit) {
			this.setState({selected: [], edit: false})

		} else {
			this.setState({selected: defaultSelected, edit: true, changed: false, name: chat.name})

		}

	}

	handleInput = (e) => {
		this.setState({name: e.target.value, changed: true})
	}

	handleDelete = () => {
		const deleteSelected = this.props.chat
		const {firebase, profile, history, updateChatId} = this.props;
		if (deleteSelected.creator_uid === profile.id && deleteSelected.messages.length === 0) {
			updateChatId(1)
			firebase.chat(deleteSelected.id).delete().then(() => {
				history.replace('/app/chat');
				history.push('/app/chat')
			})

		}
		this.toggleEditMode()
	}

	deleteYourChat = () => {
		const deleteSelected = this.props.chat
		const { firebase, profile, history, updateChatId } = this.props;
		updateChatId(1);
		let messages = deleteSelected.messages;
		for (let i in messages) {
			if (!messages[i].deleted || !messages[i].deleted.includes(profile.id)) {
				if (!messages[i].deleted) {
					messages[i].deleted = [];
				}

				messages[i].deleted.push(profile.id);
			}
		}

		let deleted = (deleteSelected.deleted && deleteSelected.deleted.length > 0) ? deleteSelected.deleted.push(profile.id) : [profile.id];
		try {
			let chatRef = firebase.chats().doc(deleteSelected.id);
			chatRef.update({ deleted: deleted, messages: messages }).then(() => {
				history.replace('/app/chat');
				history.push('/app/chat')
			});
		} catch (error) {
			console.log(error)
		}
	}

	filterListWithSearch = (list, search = '') => {
		return list.filter(student => {
			if (student.first_name) {
				return (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(search.toLowerCase());
			} else {
				return false;
			}
		})
	};

	render() {
		const {title, members, profile, chat, search} = this.props;
		const {selected, confirmDelete, edit, students, faculty, changed, name} = this.state;
		const id = profile.id

		const studentList = this.filterListWithSearch((edit ? students.filter(student => student.id !== id) : members.filter(student => student.id.length === 7 && student.id !== id)), search);
		const facultyList = this.filterListWithSearch((edit ? faculty.filter(student => (student.id !== id && student.id !== chat.creator_uid)) : members.filter(faculty => faculty.id.length !== 7 && faculty.id !== id)), search);
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex flexDirection='row' onClick={overlay.show} {...overlay}>
							<Box>
								<Heading pt={2}>{title}</Heading>
							</Box>
							<Box pt={'14px'}> <IosArrowForward color={'black'} fontSize={'28px'}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay}>

							<Fragment>
								<ConfirmDelete visible={confirmDelete} toggle={() => {
									this.setState({ confirmDelete: false })
									overlay.hide()
								}}
									handleConfirm={() => {
										this.deleteYourChat()

										this.setState({ confirmDelete: false })

										overlay.hide()
									}}/>
								{edit ?
									// this button saves Updated chat members list if changes were made
									<FloatingButton disabled={!changed} bg={changed ? 'purple' : 'meta'}
									                onClick={this.handleUpdate}><Image src={check}/></FloatingButton>
									:
									// if not in edit mode, show the floating button with edit and delete
									<Fragment>
										{chat ?
											<Fab
												mainButtonStyles={{
													marginBottom: '22px',
													backgroundColor: '#FFC61A',
													width: '47px',
													height: '47px'
												}}
												icon={<MdAdd color={'white'}/>
												}
												event={'click'}
												actionButtonStyles={{color: 'black'}}
											>

												<Action
													text='Edit'
													onClick={this.toggleEditMode}
												>
													<MdCreate color={'white'}/>
												</Action>
												<Action
													text='Delete'
													onClick={() => this.setState({confirmDelete: true})}
												>
													<MdTrash color={'white'}/>
												</Action>
											</Fab> :
											(this.props.chat.messages.length === 0) ? (
											<Fab
												mainButtonStyles={{
													marginBottom: '22px',
													backgroundColor: '#FFC61A',
													width: '47px',
													height: '47px'
												}}
												icon={<MdAdd color={'white'}/>
												}
												event={'click'}
												actionButtonStyles={{color: 'black'}}
											>

												
													<Action
														text='Delete'
														onClick={() => this.setState({confirmDelete: true})}
													>
														<MdTrash color={'white'}/>
													</Action>
												 

											</Fab>) : null}
									</Fragment>}
							</Fragment>
							<Box>

								<Tabs.Container>
									{tabs => (
										<Block>
											<HeaderWrapper boxShadow={'main'} width={1}>
												<Box ml={0} pt={3} px={2}>
													{edit ? <IosClose fontSize={'30px'} onClick={this.toggleEditMode}/> :
														<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>}
												</Box>


												{edit && chat.is_group ?
													<Input fontSize={'24px'} marginBottom={0} placeholder={'Group name...'} fontWeight={800}
													       value={name} onChange={this.handleInput}/> :
													<Text fontSize={'24px'} p={2} pl={3} fontWeight={600} color={'black'}>Members</Text>}

												<Tabs marginTop={edit ? '-8px' : 0}>
													<Tabs.Tab tab="first" {...tabs}><Box
														onClick={() => {
															this.setState({isStudentTab: true});
															this.props.clearSearch();
														}}><TabHeader title={'Students'}/></Box></Tabs.Tab>
													<Tabs.Tab tab="second" {...tabs}><Box
														onClick={() => {
															this.setState({isStudentTab: false});
															this.props.clearSearch();
														}}><TabHeader title={'Faculty'}/></Box></Tabs.Tab>
												</Tabs>
											</HeaderWrapper>

											<Content pt={2}>
												<SearchInput placeholders={this.state.isStudentTab ? 'Search Student' : 'Search Faculty'}/>
												<Tabs.Panel tab="first" {...tabs}>
													{/*{loading ? <Loading/> :*/}

													<ListWrapper>
														<UserList students={studentList}
														          handleUserClick={this.handleSelect} selected={selected}/>
													</ListWrapper>
													{/*}*/}
												</Tabs.Panel>
												<Tabs.Panel tab="second" {...tabs}>
													{/*{loading ? <Loading/> :*/}

													<ListWrapper>
														<UserList students={facultyList}
														          handleUserClick={this.handleSelect} selected={selected} facultyList/>

													</ListWrapper>
													{/*}*/}
												</Tabs.Panel>

											</Content>

										</Block>
									)}
								</Tabs.Container>
							</Box>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}


const mapStateToProps = state => ({
	search: searchSelectors.refreshSearch(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	updateChatId: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});


export default withRouter(withFirebase(connect(mapStateToProps, mapDispatchToProps)(ChatMembers)));
